import { useState } from "react";

import { toast } from "react-toastify";
import { Loader2, PhoneCall } from "lucide-react";

import { Button } from "../ui/button";
import toastError from "../../errors/toastError";
import usePermissions from "../../hooks/usePermissions";
import { useLigacoes, ligar } from "../../ligacoes/store";

// Botão "ligar pelo WhatsApp" para um cliente. Só aparece com o módulo de
// ligações instalado, a empresa com aparelho pareado e permissão de ligar.
// Com ticket, a ligação fica registrada na própria conversa; sem ticket
// (lista de contatos), abre ou continua o atendimento do número.
const LigarWhatsAppButton = ({ ticket, contact, className }) => {
	const lig = useLigacoes();
	const { temPermissao } = usePermissions();
	const [ligando, setLigando] = useState(false);

	if (!lig.disponivel || !temPermissao("calls:make")) return null;

	const alvo = ticket?.contact || contact;
	const grupo = ticket?.isGroup || alvo?.isGroup;
	const numero = String(alvo?.number || "").replace(/\D/g, "");
	const emLigacao = Boolean(lig.minha);
	const podeLigar = !grupo && numero.length >= 10 && !emLigacao;

	const motivo = grupo
		? "Não dá para ligar para um grupo"
		: numero.length < 10
			? "Contato sem número de telefone"
			: emLigacao
				? "Encerre a ligação atual primeiro"
				: `Ligar pelo WhatsApp para ${numero}`;

	const clicar = async () => {
		setLigando(true);
		try {
			await ligar(ticket?.id ? { ticketId: ticket.id } : { number: numero });
		} catch (err) {
			if (err?.response) toastError(err);
			else toast.error(err?.message || "Não foi possível ligar.");
		}
		setLigando(false);
	};

	return (
		<Button
			variant="ghost"
			size="icon"
			className={className || "h-8 w-8 text-emerald-600 hover:text-emerald-700"}
			aria-label={motivo}
			title={motivo}
			disabled={!podeLigar || ligando}
			onClick={clicar}
		>
			{ligando ? <Loader2 className="h-4 w-4 animate-spin" /> : <PhoneCall className="h-4 w-4" />}
		</Button>
	);
};

export default LigarWhatsAppButton;
